import React from "react";
import { Card, Divider } from "antd";
import { Height } from "@mui/icons-material";
function CustomPatientDetailsCard({ item, index }) {
  return (
    <>
      {/* <div style={{display:"flex"}}> */}
      <Card
        size="small"
        style={{ backgroundColor: "WhiteSmoke", height: "100%" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <div
              style={{
                fontSize: "small",
                fontWeight: "600",
                color: item.labelColor,
              }}
            >
              {item.value}
            </div>
            <div
              style={{
                fontSize: "small",
                fontWeight: "600",
                // color: item.labelColor,
              }}
            >
              {item.label}
            </div>
          </div>
          {/* <div>
          <img src={item.icon} width="25px" height="25px"  style={{backgroundColor:"white",padding:"1px",borderRadius:"1px"}}/>
        </div> */}
        </div>
      </Card>
      {/* {index !=3 ?
    <div style={{backgroundColor:"#E5E4E2",borderRadius:"3px",width:"5px"}}></div>:null}
    </div> */}
    </>
  );
}

export default CustomPatientDetailsCard;
